// extracted by mini-css-extract-plugin
module.exports = {"container":"_194Q0sFmzw8UyJTr7dOEHl","groupsList":"YoPcHFQn-_iby6Nfaw_3t"};